import * as ActionTypes from './types.action';

export const startDownloadingPdf = () => ({
  type: ActionTypes.DOWNLOAD_INVOICE_REQUESTED,
});

export const finishDownloadingPdf = invoiceIndex => ({
  type: ActionTypes.DOWNLOAD_INVOICE_FINISHED,
  invoiceIndex,
});
